import React from 'react';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants';
import { getApi } from '../../../api/endpoints.js';
import ListingPageComponent from '../../../components/ListingPageComponent.js';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      value: ((row) => {
        return <>{row.charging_zone_detail?.circle?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Cluster',
      value: ((row) => {
        return <>{row.charging_zone_detail?.cluster?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'PIN Code',
      value: ((row) => {
        return <>{row.charging_zone_detail?.pincode?.code}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Partner',
      value: ((row) => {
        return <>{row.charging_partner?.nomenclature} - {row.charging_partner?.firm?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Zone',
      value: ((row) => {
        return <>{row.charging_zone_detail?.charging_zone?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Service Provider',
      value: ((row) => {
        return <>{row.electricity_service_provider?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Fixed Unit Rate',
      value: ((row) => {
        return <>₹ {row.electricity_service_provider?.fixed_unit_rate}</>
      }),
      disableSort: true
    },
  ];

  return <ListingPageComponent
    key={PAGES.ElectricityConfigsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.ElectricityConfigsListingPage.name)}
    breadcrumbs={[{label: "Home",  url: '/dashboard'}, { label: "Electricity", url: '/electricity/config'}, { label: "Configurations" }]}
    listingMutation={getApi('electricityConfigurations')}
    className="electricity-configurations-listing-page"
    contentHeading="Electricity Configurations List - Results"
    headers={headers}
    recordsKey="cz_load_configurations"
    searchBy={['Charging Partner ID', 'Charging Zone', 'Service Provider']}
  />
};

export default Index;



